import React from "react";

export const BreakdownSummary = ({
  currentStep,
  STEPS,
  breakdown,
  currentRent,
  formatCurrency,
  formatPercent,
  t,
  config,
  highlight = {}
}) => {
  if (currentStep < STEPS.IPC_AND_TAXES) return null;

  const rowClass = (isHighlight, defaultClass = "text-gray-800") =>
    isHighlight ? (highlight.class || "text-sky-700") : defaultClass;

  const runningTotal =
    currentRent +
    breakdown.baseIPC +
    breakdown.municipalTax +
    breakdown.schoolTax +
    (currentStep >= STEPS.WORKS ? breakdown.insurance : 0) +
    (currentStep >= STEPS.SUMMARY ? breakdown.works : 0);

  const totalIncrease = runningTotal - currentRent;

  return (
    <div className="brand-summary-card p-5 mb-6">
      <div className="flex justify-between items-center">
        <span className="text-gray-700">{t('2026.currentRent', 'Loyer actuel')}</span>
        <span className="font-bold text-lg">{formatCurrency(currentRent)}</span>
      </div>

        <div className="border-t border-gray-200 my-2" />

        <div className="space-y-1 text-sm">
          <div className={`flex justify-between items-center ${rowClass(highlight.ipc)}`}>
            <span>{t('2026.breakdown.ipc', 'IPC')} ({config.ipcLabel})</span>
            <span>+{formatCurrency(breakdown.baseIPC)}</span>
          </div>

          {currentStep >= STEPS.INSURANCE && (
            <>
              <div className="flex justify-between items-center">
                <span className={rowClass(highlight.taxes, breakdown.municipalTax > 0 ? "text-gray-800" : "text-gray-400")}>
                  {t('2026.breakdown.municipalTax', 'Taxes municipales')}
                </span>
                <span className={rowClass(highlight.taxes, breakdown.municipalTax > 0 ? "text-gray-800" : "text-gray-400")}>
                  +{formatCurrency(breakdown.municipalTax)}
                </span>
              </div>

              <div className="flex justify-between items-center">
                <span className={rowClass(highlight.taxes, breakdown.schoolTax > 0 ? "text-gray-800" : "text-gray-400")}>
                  {t('2026.breakdown.schoolTax', 'Taxes scolaires')}
                </span>
                <span className={rowClass(highlight.taxes, breakdown.schoolTax > 0 ? "text-gray-800" : "text-gray-400")}>
                  +{formatCurrency(breakdown.schoolTax)}
                </span>
              </div>
            </>
          )}

          {currentStep >= STEPS.WORKS && (
            <div className="flex justify-between items-center">
              <span className={rowClass(
                highlight.insurance || breakdown.insurance > 0 || breakdown.insuranceUnknown,
                breakdown.insurance > 0 || breakdown.insuranceUnknown ? "text-sky-700" : "text-gray-400"
              )}>
                {t('2026.summary.insurance', 'Assurances')}
              </span>
              <span className={rowClass(
                highlight.insurance || breakdown.insurance > 0 || breakdown.insuranceUnknown,
                breakdown.insurance > 0 || breakdown.insuranceUnknown ? "text-sky-700" : "text-gray-400"
              )}>
                {breakdown.insuranceUnknown ? '?' : `+${formatCurrency(breakdown.insurance)}`}
              </span>
            </div>
          )}

          {currentStep >= STEPS.SUMMARY && (
            <div className="flex justify-between items-center">
              <span className={rowClass(highlight.works, breakdown.works > 0 ? "text-gray-800" : "text-gray-400")}>
                {t('2026.summary.works', 'Travaux')}
              </span>
              <span className={rowClass(highlight.works, breakdown.works > 0 ? "text-gray-800" : "text-gray-400")}>
                +{formatCurrency(breakdown.works)}
              </span>
            </div>
          )}
        </div>

        <div className="border-t border-gray-200 my-2" />

        <div className="flex justify-between items-center">
          <span className="text-gray-700 font-medium">{t('2026.estimatedRent', 'Loyer estimé')}</span>
          <span className="font-bold text-xl text-gray-900">{formatCurrency(runningTotal)}</span>
        </div>
        <div className="flex justify-between items-center text-sm text-gray-500">
          <span>{t('2026.increase', 'Augmentation')}</span>
          <span>+{formatCurrency(totalIncrease)} ({formatPercent(totalIncrease / currentRent)})</span>
        </div>
    </div>
  );
};
